import { useEffect, useState } from 'react';
import { DEFAULT_SECTIONS } from '../config/sectionTypes';

const LS_KEY = 'videbits-dashboard-layout';

function readLocalLayout() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed?.sections) && parsed.sections.length ? parsed.sections : null;
  } catch (_) {
    return null;
  }
}

// Resolves the ordered list of dashboard sections for the current user:
//  - Authenticated: their saved layout from the API (falls back to default).
//  - Anonymous: a locally-saved layout if present, else the default.
// Always returns a usable array, so the home page renders even if the
// request fails.
export default function useDashboardSections({ apiBase, isAuthenticated, token }) {
  const [sections, setSections] = useState(DEFAULT_SECTIONS);

  useEffect(() => {
    let cancelled = false;
    if (isAuthenticated && token) {
      fetch(`${apiBase}/preferences/dashboard`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          if (cancelled) return;
          const secs = data && data.layout && data.layout.sections;
          setSections(Array.isArray(secs) && secs.length ? secs : DEFAULT_SECTIONS);
        })
        .catch(() => { if (!cancelled) setSections(DEFAULT_SECTIONS); });
    } else {
      setSections(readLocalLayout() || DEFAULT_SECTIONS);
    }
    return () => { cancelled = true; };
  }, [apiBase, isAuthenticated, token]);

  return sections;
}
